import { render, staticRenderFns } from "./perimTechno.vue?vue&type=template&id=d65da052&scoped=true"
import script from "./perimTechno.vue?vue&type=script&lang=js"
export * from "./perimTechno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65da052",
  null
  
)

export default component.exports